export default __webpack_public_path__ + "static/545-22008184b51b21c510399a5a1762e5b0.gif";